import { render, staticRenderFns } from "./customizationGPTs.vue?vue&type=template&id=53c33644&scoped=true"
import script from "./customizationGPTs.vue?vue&type=script&lang=js"
export * from "./customizationGPTs.vue?vue&type=script&lang=js"
import style0 from "./customizationGPTs.vue?vue&type=style&index=0&id=53c33644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c33644",
  null
  
)

export default component.exports